<template>
  <div class="mailbox-verification-zoho-confirmation-code-finder">
    <!-- Polling for verification -->
    <template v-if="pollingForVerification">
      <h3>Searching for a confirmation code from Zoho...</h3>
      <p>Give us a few seconds as we wait for the email to arrive.</p>
      <verification-loader />
    </template>
    <!-- Found confirmation code -->
    <template v-else-if="hasConfirmationCode">
      <h3>We found the confirmation code!</h3>
      <p>Paste this code in the pop-up field in Zoho, click <strong>"Confirm"</strong>, then come back here.</p>
      <p><br></p>
      <i class="ddi ddi-arrow-down bouncy" />
      <clipboard-text id="zohoConfirmationCode" :text="confirmationCode" />
      <div class="bottom-centered">
        <dd-button type="text" @click="pollForVerificationEmail()">
          Not the right code? Check again.
        </dd-button>
        <dd-button type="flat" @click="$emit('confirmed')">I've confirmed the code in Zoho.</dd-button>
      </div>
    </template>
    <!-- Did not find confirmation code -->
    <template v-else>
      <h3>We did not find a confirmation code.</h3>
      <p><br></p>
      <ul>
        <li><strong><a href="#" class="just-a-link" @click.stop.prevent="pollForVerificationEmail()">Check again</a></strong>. Sometimes
          the email may take a minute to get here.</li>
        <li><strong><a href="#" class="just-a-link" @click.stop.prevent="$emit('go-back-clicked')">Go back to the beginning</a></strong>
          and review our auto-forwarding instructions again.</li>
        <li>At a loss? <strong><a href="https://www.donedone.com/help-center" target="_blank" class="just-a-link">Reach out to us</a></strong>
          so we can help.</li>
      </ul>
    </template>
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */
import MailboxesAPI from '@/api/modules/mailboxes.api'

export default defineComponent({
  name: 'MailboxVerificationZohoConfirmationCodeFinder',

  emits: ['confirmed', 'go-back-clicked'],

  data() {
    return {
      pollingForVerification: true,
      hasConfirmationCode: false,
      poller: null as any,
      pollCount: 0,
      pollIntervalInMS: 5000,
      pollMax: 12,
      confirmationCode: '',
    }
  },

  computed: {
    mailboxID(): number {
      return Number(this.$route.params.id)
    },
  },

  watch: {
    pollCount: {
      handler(newValue) {
        if (newValue >= this.pollMax) {
          this.endPolling()
        }
      },
    },
  },

  beforeUnmount() {
    this.endPolling()
  },

  async created() {
    this.pollForVerificationEmail()
  },

  methods: {
    endPolling() {
      clearInterval(this.poller)
      this.pollingForVerification = false
    },
    pollForVerificationEmail() {
      this.hasConfirmationCode = false
      this.pollingForVerification = true
      this.pollCount = 0
      this.poller = setInterval(async () => {
        this.pollCount++
        await this.getMostRecentZohoConfirmationCode()
      }, this.pollIntervalInMS)
    },
    async getMostRecentZohoConfirmationCode() {
      try {
        const response = await MailboxesAPI.get_MostRecentZohoConfirmationCode(
          this.mailboxID,
        )
        this.confirmationCode = response.code
        this.hasConfirmationCode = true
        this.endPolling()
      } catch (err) {
        console.log('No confirmation code found.')
      }
    },
  },
})
</script>

<style lang="scss">
.mailbox-verification-zoho-confirmation-code-finder {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
